import { makeStyles } from "@material-ui/core";

export const useSuburbStyles = makeStyles((theme) => ({
  hiddenMovile: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));
